/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Workout_Superset_NextInputs */

const en_us2_workout_superset_next = /** @type {(inputs: Workout_Superset_NextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`No rest: ${i?.name} comes next`)
};

const pt_br2_workout_superset_next = /** @type {(inputs: Workout_Superset_NextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sem descanso: em seguida, ${i?.name}`)
};

const es_419_workout_superset_next = /** @type {(inputs: Workout_Superset_NextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sin descanso: sigue ${i?.name}`)
};

const pt_pt2_workout_superset_next = /** @type {(inputs: Workout_Superset_NextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sem descanso: a seguir, ${i?.name}`)
};

const fr_fr2_workout_superset_next = /** @type {(inputs: Workout_Superset_NextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sans repos : ${i?.name} ensuite`)
};

const de_de2_workout_superset_next = /** @type {(inputs: Workout_Superset_NextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Keine Pause: Als Nächstes ${i?.name}`)
};

const it_it2_workout_superset_next = /** @type {(inputs: Workout_Superset_NextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Senza recupero: ora tocca a ${i?.name}`)
};

/**
* | output |
* | --- |
* | "No rest: {name} comes next" |
*
* @param {Workout_Superset_NextInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_superset_next = /** @type {((inputs: Workout_Superset_NextInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Superset_NextInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_superset_next(inputs)
	if (locale === "es-419") return es_419_workout_superset_next(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_superset_next(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_superset_next(inputs)
	if (locale === "de-DE") return de_de2_workout_superset_next(inputs)
	if (locale === "it-IT") return it_it2_workout_superset_next(inputs)
	return en_us2_workout_superset_next(inputs)
});
export { workout_superset_next as "workout.superset_next" }